export default __webpack_public_path__ + "static/media/onboarding_second.1e510c16.png";